import { Button, Form, Checkbox, message, Modal, Tabs, Upload, Select, Collapse, Card } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CollectionServer, deleteInArray, DropdownAction, errorCatch, GET, GETWITH, JSX, JSXMap, Model, POST, POSTFormData, QueryDetail, QueryOrder, QueryParam, QueryParams, updateInArray, useCollectionRef } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import confirmKey from '../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';
import { DatabaseOutlined, DeleteOutlined, ExclamationCircleOutlined, FileExcelOutlined, UploadOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/ru_RU';
import { DatePicker, Space } from 'antd';
import User from '../../../common/User';
import PageLayout from '../../components/PageLayout';
const { RangePicker } = DatePicker;
const { Option } = Select;
var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');


function DataRow({ auth, item, idx, account: meropriyatie, setCollectionItem, modelActions, collection, setCollection }) {
    // const [collapsed, setCollapsed] = useState(true);

    const rowColor = (false) ? "bg-red" : "bg-grey";
    return (<React.Fragment key={idx}>
        <tr key={idx}>
            {/* <td className={`fill`}>
                <div>
                    ({item?.tantsevalnayaDistsiplinaID}) {item?.tantsevalnayaDistsiplina?.nazvanie}
                </div>
            </td> */}
            <td className={`fill`}>
                <div className={`bg bg-${(item?.polzovatel?.genderID === 1) ? "blue" : "red"}`} style={{ textAlign: "left" }}>
                    {item?.polzovatel?.lastname} {item?.polzovatel?.firstname}
                </div>
            </td>
            <td className={`fill`} style={{ textAlign: "center" }}>
                <div>
                    {item?.vkhodyashchiiReiting}
                </div>
            </td>
            <td className={`fill`} onClick={(e) => { e.stopPropagation() }}>
                <DropdownAction
                    style={{ padding: "0" }}
                    button={() => (<div className={`bg ${rowColor} pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                        <i className="fa fa-ellipsis-h"></i>
                    </div>)}
                    items={modelActions(item, idx)?.map((e, idx) => ({
                        key: e.key || idx,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        collection: collection,
                        setCollection: setCollection,
                        ...e
                    }))} />
            </td>
        </tr>
    </React.Fragment>)
}

export default function FederationadministratorBegindatarating(props) {
    const { auth, object } = props;

    const filters = () => [
        {
            label: "Танцевальная дисциплина",
            name: "tantsevalnayaDistsiplina",
            filterType: "group",
            display: (o) => o.nazvanie,
            queryFilter: [
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: true,
            filter: true,
        },
        {
            name: "polzovatel.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "polzovatel.firstname",
            sort: true,
            filter: true,
        },
        {
            name: "polzovatel.gender",
            display: (o) => o.name,
            queryFilter: [
                QueryOrder("name", "ASC"),
            ],
            sort: true,
            filter: true,
        },
        {
            label: "Входящий рейтинг",
            name: "vkhodyashchiiReiting",
            sort: true,
            filter: true,
        },
    ];

    const cref = useCollectionRef()
    const [loading, setLoading] = useState(false)
    const [errorList, setErrorList] = useState([])
    const [tantsevalnayaDistsiplinaID, setTantsevalnayaDistsiplinaID] = useState()
    const [tantsevalnieDistsiplini, setTantsevalnieDistsiplini] = useState([])
    const [genderID, setGenderID] = useState()
    const gender = [
        { ID: 1, name: "Мужской" },
        { ID: 2, name: "Женский" },
    ]
    useEffect(() => {
        setLoading(true);
        GET(auth, `/api/query/TantsevalnieDistsiplini?s-nazvanie=asc`,
            ({ data }) => {
                setTantsevalnieDistsiplini(data)
                setLoading(false);
            },
            (err) => errorCatch(err, setLoading(false)));
    }, []);

    useEffect(() => {
        setErrorList([])
    }, [tantsevalnayaDistsiplinaID, genderID]);

    return (
        <PageLayout>
        <Card size="small" style={{ width: "100%" }}>
            {props.subheader}

            {(tantsevalnieDistsiplini && tantsevalnieDistsiplini.length > 0) && <div>
                <div style={{ paddingBottom: "15px", display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "200px" }}>Танцевальная дисциплина:</div>
                    <Select value={tantsevalnayaDistsiplinaID} style={{ width: "200px" }} onChange={setTantsevalnayaDistsiplinaID}
                        showSearch
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {JSXMap(tantsevalnieDistsiplini, (item, idx) => {
                            return (<Option value={item.ID} key={idx}>{item.nazvanie}</Option>)
                        })}
                    </Select>
                </div>
                <div style={{ paddingBottom: "15px", display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "200px" }}>Пол:</div>
                    <Select value={genderID} style={{ width: "200px" }} onChange={setGenderID}>
                        {JSXMap(gender, (item, idx) => {
                            return (<Option value={item.ID} key={idx}>{item.name}</Option>)
                        })}
                    </Select>
                </div>
            </div>}

            {(errorList?.length > 0) && <Collapse style={{marginBottom: "15px", backgroundColor: "#ffa2a2"}} items={[{
                    key: '1',
                    label: 'Ошибки',
                    children: <div style={{ color: "red", fontSize: "13px", }}>
                    {JSXMap(errorList, (item, idx) => {
                        return (<div key={idx}>
                            [{idx + 1}] {item}
                        </div>)
                    })}</div>,
                }]} defaultActiveKey={['1']} />}
            {(tantsevalnieDistsiplini && tantsevalnieDistsiplini.length > 0 && tantsevalnayaDistsiplinaID > 0 && genderID > 0) && <CollectionServer
                auth={auth}
                name={"BeginRating"}
                source={'/api/query/BeginRating'}
                contextFilters={() => [
                    QueryOrder("vkhodyashchiiReiting", "DESC"),
                    QueryOrder("Polzovatel.Lastname", "ASC"),
                    QueryOrder("Polzovatel.Firstname", "ASC"),
                    QueryParam("w-TantsevalnayaDistsiplina", tantsevalnayaDistsiplinaID),
                    QueryParam("w-Polzovatel.Gender", genderID),
                ]}
                collectionRef={cref}
                filters={filters}
                customRender={(items, {
                    collection,
                    setCollection,
                    setCollectionItem,
                    removeCollectionItem,
                    collectionActions,
                    modelActions,
                    update
                }) => (
                    <div className='scrollable'>
                        <table className="table" style={{ fontSize: "13px" }}>
                            <thead>
                                <tr>
                                    {/* <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Танцевальная дисциплина</div></th> */}
                                    <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Участник</div></th>
                                    <th className={`wrap`} style={{ minWidth: "45px", maxWidth: "45px" }}><div className='bg bg-grey dark-1'>Входящий рейтинг</div></th>
                                    <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px" }}>
                                {JSXMap(items, (o, oidx) => {
                                    return (<DataRow key={oidx} auth={auth} item={o} idx={oidx} meropriyatie={object} collection={collection} setCollection={setCollection} setCollectionItem={setCollectionItem} modelActions={modelActions} />)
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
                size={"small"}

                collectionActions={() => [{
                    auth: auth,
                    action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/begin-rating/create`, { ...values, tantsevalnayaDistsiplinaID }, ({ data }) => {
                        setCollection(updateInArray(collection, data));
                        close();
                    }, (err) => errorCatch(err, unlock)),
                    title: "Добавить строку входящего рейтинга",
                    form: Model,
                    meta: [
                        // {
                        //     label: "Танцевальная дисциплина",
                        //     name: "tantsevalnayaDistsiplina",
                        //     type: "object",
                        //     relation: {
                        //         display: (item) => {
                        //             return item.nazvanie
                        //         },
                        //         reference: { object: "TantsevalnieDistsiplini", property: "ID" },
                        //         type: "many-one",
                        //     },
                        //     queryFilter: [
                        //         QueryDetail("model"),
                        //         QueryOrder("nazvanie", "ASC")
                        //     ]
                        // },
                        {
                            label: "Участник",
                            name: "polzovatel",
                            type: "object",
                            mode: "dialog",
                            modal: { width: "700px" },
                            relation: {
                                uiFilter: () => [
                                    {
                                        name: "lastname",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "firstname",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "patronymic",
                                        sort: true,
                                        filter: true,
                                    },

                                    {
                                        name: "email",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        label: "Телефон",
                                        name: "phone",
                                        sort: true,
                                        filter: true,
                                    },
                                    // {
                                    //     name: "gender",
                                    //     sort: true,
                                    //     filter: true,
                                    //     display: (o) => o.name,
                                    // },
                                    {
                                        label: "Дата создания",
                                        name: "createdAt",
                                        type: "date",
                                        sort: true,
                                        filter: true,
                                    },
                                ],
                                displayString: (item) => {
                                    return item?.lastname + " " + item?.firstname
                                },
                                display: (item) => {
                                    return (
                                        <User item={item} />
                                    )
                                },
                                reference: { object: "User", property: "ID", },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryDetail("combobox"),
                                QueryOrder("firstname", "ASC"),
                                QueryParam("w-Gender", genderID),
                            ]
                        },
                        // {
                        //     label: "Участник",
                        //     name: "uchastnik",
                        //     type: "func",
                        //     render: (auth, item, value, onChange) => {
                        //         return (
                        //             <InputWithSearchModal value={value} onChange={onChange} valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{}}
                        //                 searchForm={UserFilter}
                        //                 selectForm={UserSelector} />
                        //         )
                        //     }
                        // },
                        {
                            label: "Входящий рейтинг",
                            name: "vkhodyashchiiReiting",
                            type: "float",
                        },
                    ],
                },
                ({ collection,
                    setCollection,
                    setCollectionItem,
                    removeCollectionItem,
                    onSelection,
                    isSelected,
                    lock,
                    unlock,
                    loading: collectionLoading,
                    update }, idx) => {
                    return (<Upload key={idx} {...{
                        name: 'file',
                        multiple: false,
                        showUploadList: false,
                        accept: ".xlsx",
                        beforeUpload: (f) => {
                            setLoading(true);

                            const formData = new FormData();
                            formData.append('file', f);

                            POSTFormData(auth, `/api/begin-rating/check-file/${tantsevalnayaDistsiplinaID}/${genderID}`, formData,
                                (res) => {
                                    if (res?.errorlist?.length) {
                                        setErrorList(res.errorlist)
                                    }
                                    // update();
                                    setLoading(false);
                                },
                                (err) => { errorCatch(err, () => setLoading(false)) });

                            return false;
                        },
                    }}>
                        <Button loading={loading} icon={<UploadOutlined />}>Проверить файл</Button>
                    </Upload>)
                },
                ({ collection,
                    setCollection,
                    setCollectionItem,
                    removeCollectionItem,
                    onSelection,
                    isSelected,
                    lock,
                    unlock,
                    loading: collectionLoading,
                    update }, idx) => {
                    return (<Upload key={idx} {...{
                        name: 'file',
                        multiple: false,
                        showUploadList: false,
                        accept: ".xlsx",
                        beforeUpload: (f) => {
                            setLoading(true);

                            const formData = new FormData();
                            formData.append('file', f);

                            POSTFormData(auth, `/api/begin-rating/create-by-excel/${tantsevalnayaDistsiplinaID}/${genderID}`, formData,
                                (res) => {
                                    if (res?.errorlist?.length) {
                                        setErrorList(res.errorlist)
                                    }
                                    update();
                                    setLoading(false);
                                },
                                (err) => { errorCatch(err, () => setLoading(false)) });

                            return false;
                        },
                    }}>
                        <Button loading={loading} icon={<FileExcelOutlined />}>Загрузить из Excel</Button>
                    </Upload>)
                },
                    ,
                ({ collection,
                    setCollection,
                    setCollectionItem,
                    removeCollectionItem,
                    onSelection,
                    isSelected,
                    lock,
                    unlock,
                    loading: collectionLoading,
                    update }, idx) => {
                    return (<Button key={idx} style={{ color: "red" }}
                        loading={loading}
                        icon={<DeleteOutlined />}
                        onClick={(e) => {
                            confirmKey({
                                pass: '123',
                                title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить входящий рейтинг танцоров</span>,
                                icon: undefined,
                                content: <span>Вы действительно хотите удалить входящий рейтинг танцоров выбранного пола для текущей танцевальной дисциплины?</span>,
                                okText: 'Удалить',
                                cancelText: 'Отмена',
                                onOk() {
                                    return new Promise((resolve, reject) => {
                                        GET(auth, `/api/begin-rating/delete-tants-gender/${tantsevalnayaDistsiplinaID}/${genderID}`,
                                            ({ data }) => {
                                                setCollection([]);
                                                resolve(data);
                                            }, (err) => errorCatch(err, reject));
                                    }).catch(() => { });
                                },
                                onCancel() {
                                },
                            })

                            return false;
                        }}>
                        Удалить все по ТД и полу
                    </Button>)
                },
                ]}
                modelActions={(item) => [{
                    auth: auth,
                    title: "Изменить",
                    modal: {
                        width: "600px",
                        title: "Изменить строку входящего рейтинга",
                    },
                    object: item,
                    action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/begin-rating/update`, { ...item, ...values, ID: item.ID },
                        ({ data }) => {
                            setCollection(updateInArray(collection, data));
                            close();
                        },
                        (err) => errorCatch(err, unlock)),
                    form: Model,
                    meta: [
                        {
                            type: "func",
                            render: (auth, _item) => {
                                return (<div>
                                    <div>{item?.tantsevalnayaDistsiplina?.nazvanie}</div>
                                    <div><User item={item?.polzovatel} /></div>
                                </div>)
                            }
                        },
                        // {
                        //     label: "Танцевальная дисциплина",
                        //     name: "tantsevalnayaDistsiplina",
                        //     type: "object",
                        //     relation: {
                        //         display: (item) => {
                        //             return item.nazvanie
                        //         },
                        //         reference: { object: "TantsevalnieDistsiplini", property: "ID" },
                        //         type: "many-one",
                        //     },
                        //     queryFilter: [
                        //         QueryDetail("model"),
                        //         QueryOrder("nazvanie", "ASC")
                        //     ]
                        // },
                        // {
                        //     label: "Участник",
                        //     name: "polzovatel",
                        //     type: "object",
                        //     mode: "dialog",
                        //     modal: { width: "700px" },
                        //     relation: {
                        //         uiFilter: () => [
                        //             {
                        //                 name: "lastname",
                        //                 sort: true,
                        //                 filter: true,
                        //             },
                        //             {
                        //                 name: "firstname",
                        //                 sort: true,
                        //                 filter: true,
                        //             },
                        //             {
                        //                 name: "patronymic",
                        //                 sort: true,
                        //                 filter: true,
                        //             },

                        //             {
                        //                 name: "email",
                        //                 sort: true,
                        //                 filter: true,
                        //             },
                        //             {
                        //                 label: "Телефон",
                        //                 name: "phone",
                        //                 sort: true,
                        //                 filter: true,
                        //             },
                        //             {
                        //                 name: "gender",
                        //                 sort: true,
                        //                 filter: true,
                        //                 display: (o) => o.name,
                        //             },
                        //             {
                        //                 label: "Дата создания",
                        //                 name: "createdAt",
                        //                 type: "date",
                        //                 sort: true,
                        //                 filter: true,
                        //             },
                        //         ],
                        //         displayString: (item) => {
                        //             return item?.lastname + " " + item?.firstname
                        //         },
                        //         display: (item) => {
                        //             return (
                        //                 <User item={item} />
                        //             )
                        //         },
                        //         reference: { object: "User", property: "ID", },
                        //         type: "many-one",
                        //     },
                        //     queryFilter: [
                        //         QueryDetail("combobox"),
                        //         QueryOrder("firstname", "ASC")
                        //     ]
                        // },
                        {
                            label: "Входящий рейтинг",
                            name: "vkhodyashchiiReiting",
                            type: "float",
                        },
                    ],
                },
                {
                    auth: auth,
                    title: <span style={{ color: "red" }}>Удалить</span>,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        confirmKey({
                            pass: '123',
                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить строку входящего рейтинга</span>,
                            icon: undefined,
                            content: <span>Вы действительно хотите удалить строку входящего рейтинга?</span>,
                            okText: 'Удалить',
                            cancelText: 'Отмена',
                            onOk() {
                                return new Promise((resolve, reject) => {
                                    GET(auth, '/api/begin-rating/delete/' + item.ID,
                                        ({ data }) => {
                                            setCollection(deleteInArray(collection, item));
                                            resolve(data);
                                        }, (err) => errorCatch(err, reject));
                                }).catch(() => { });
                            },
                            onCancel() {
                            },
                        })
                    }
                }]}
            />}
        </Card>
        </PageLayout>
    );
}
